import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { catchWithSentry } from '@/hooks/useCatchWithSentry'
import { usePdfDownload } from '@/hooks/usePdfDownload'
import { useMakeBackgroundCheckOpenedMutation } from '@/store/api/Person/Person.query'

interface ActionsTypes {
  pdf?: string
  id: string
  subjectId: string
}

export const Actions = ({ pdf, id, subjectId }: ActionsTypes) => {
  const { t } = useTranslation()
  const [makeBackgroundCheckOpened] = useMakeBackgroundCheckOpenedMutation()
  const { downloadPdf, isDownloading } = usePdfDownload({ reportId: subjectId })

  const onPressDowload = async () => {
    if (pdf) {
      // Use the new endpoint to get a signed URL
      await downloadPdf()
    }
    try {
      await makeBackgroundCheckOpened({ id: id }).unwrap()
    } catch (e) {
      catchWithSentry(e)
      console.error(e)
    }
  }

  return (
    <Button
      onClick={onPressDowload}
      isLoading={isDownloading}
      className="w-min hover:cursor-pointer max-sm:h-9 max-sm:text-xs max-sm:px-2"
    >
      {t('report.generalInfo.download')}
    </Button>
  )
}
